import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import ToggleColorMode from './ToggleColorMode';
import ClientProvider from './client';
export default createDemo(import.meta.url, ToggleColorMode, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/customization/dark-mode/demos/toggle-color-mode/ToggleColorMode.tsx",
    "fileName": "ToggleColorMode.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import Box from '@mui/material/Box';\nimport RadioGroup from '@mui/material/RadioGroup';\nimport Radio from '@mui/material/Radio';\nimport FormControl from '@mui/material/FormControl';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport FormLabel from '@mui/material/FormLabel';\nimport { ThemeProvider, createTheme, useColorScheme } from '@mui/material/styles';\n\nfunction MyApp() {\n  const { mode, setMode } = useColorScheme();\n  if (!mode) {\n    return null;\n  }\n  return (\n    <Box\n      sx={{\n        display: 'flex',\n        width: '100%',\n        alignItems: 'center',\n        justifyContent: 'center',\n        bgcolor: 'background.default',\n        color: 'text.primary',\n        borderRadius: 1,\n        p: 3,\n        minHeight: '56px',\n      }}\n    >\n      <FormControl>\n        <FormLabel id=\"demo-theme-toggle\">Theme</FormLabel>\n        <RadioGroup\n          aria-labelledby=\"demo-theme-toggle\"\n          name=\"theme-toggle\"\n          row\n          value={mode}\n          onChange={(event) =>\n            setMode(event.target.value as 'system' | 'light' | 'dark')\n          }\n        >\n          <FormControlLabel value=\"system\" control={<Radio />} label=\"System\" />\n          <FormControlLabel value=\"light\" control={<Radio />} label=\"Light\" />\n          <FormControlLabel value=\"dark\" control={<Radio />} label=\"Dark\" />\n        </RadioGroup>\n      </FormControl>\n    </Box>\n  );\n}\n\nconst theme = createTheme({\n  colorSchemes: {\n    dark: true,\n  },\n});\n\nexport default function ToggleColorMode() {\n  return (\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 2,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    <ThemeProvider theme={theme}>\n      <MyApp />\n    </ThemeProvider>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 60,
        "focusedLines": 3,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import Box from '@mui/material/Box';\nimport RadioGroup from '@mui/material/RadioGroup';\nimport Radio from '@mui/material/Radio';\nimport FormControl from '@mui/material/FormControl';\nimport FormControlLabel from '@mui/material/FormControlLabel';\nimport FormLabel from '@mui/material/FormLabel';\nimport { ThemeProvider, createTheme, useColorScheme } from '@mui/material/styles';\n\nfunction MyApp() {\n  const { mode, setMode } = useColorScheme();\n  if (!mode) {\n    return null;\n  }\n  return (\n    <Box\n      sx={{\n        display: 'flex',\n        width: '100%',\n        alignItems: 'center',\n        justifyContent: 'center',\n        bgcolor: 'background.default',\n        color: 'text.primary',\n        borderRadius: 1,\n        p: 3,\n        minHeight: '56px',\n      }}\n    >\n      <FormControl>\n        <FormLabel id=\"demo-theme-toggle\">Theme</FormLabel>\n        <RadioGroup\n          aria-labelledby=\"demo-theme-toggle\"\n          name=\"theme-toggle\"\n          row\n          value={mode}\n          onChange={(event) =>\n            setMode(event.target.value as 'system' | 'light' | 'dark')\n          }\n        >\n          <FormControlLabel value=\"system\" control={<Radio />} label=\"System\" />\n          <FormControlLabel value=\"light\" control={<Radio />} label=\"Light\" />\n          <FormControlLabel value=\"dark\" control={<Radio />} label=\"Dark\" />\n        </RadioGroup>\n      </FormControl>\n    </Box>\n  );\n}\n\nconst theme = createTheme({\n  colorSchemes: {\n    dark: true,\n  },\n});\n\nexport default function ToggleColorMode() {\n  return (\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        "    <ThemeProvider theme={theme}>\n      <MyApp />\n    </ThemeProvider>\n"
      ],
      [
        "span",
        "frame",
        "  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 2,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 56
            },
            [
              "    <",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "theme"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi di-jv",
                "theme"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 57
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "MyApp"
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 58
            },
            [
              "    </",
              [
                "span",
                "pl-c1 di-jsx",
                "ThemeProvider"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 60,
    "focusedLines": 3,
    "collapsible": true,
    "externals": [
      "@mui/material/Box",
      "@mui/material/RadioGroup",
      "@mui/material/Radio",
      "@mui/material/FormControl",
      "@mui/material/FormControlLabel",
      "@mui/material/FormLabel",
      "@mui/material/styles"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
